<template>
<div>
    <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab" img-width="1024" img-height="480" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
        <!-- Text slides with image -->
        <b-carousel-slide v-for="(slided,index) in slideData" :caption="slided.title_caption" :text="slided.caption" :img-src="wurl+'/imgsrv/'+slided.slide_file"></b-carousel-slide>
    </b-carousel>
    <div class="headlinehome">
        <b-container class="mx-auto">
            <b-row>
                <b-col lg="4" md="4" sm="6" xs="12" class="d-flex justify-content-center">
                    <b-card :title="this.item_left_title" :img-src="wurl+'/imgsrv/'+this.item_left_icon" img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                        <b-card-text>
                            {{ this.item_left_resume }}
                        </b-card-text>
                        <b-button :to="this.item_left_link" squared>Lire la suite</b-button>
                    </b-card>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" class="d-flex justify-content-center">
                    <b-card :title="this.item_center_title" :img-src="wurl+'/imgsrv/'+this.item_center_icon" img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                        <b-card-text>
                            {{ this.item_center_resume }}
                        </b-card-text>
                        <b-button :to="this.item_center_link" squared>Lire la suite</b-button>
                    </b-card><br><br>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" class="d-flex justify-content-center">
                    <b-card :title="this.item_right_title" :img-src="wurl+'/imgsrv/'+this.item_right_icon" img-alt="Image" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                        <b-card-text>
                            {{ this.item_right_resume }}
                        </b-card-text>

                        <b-button :to="this.item_right_link" squared>Lire la suite</b-button>
                    </b-card><br><br>
                </b-col>
            </b-row>
        </b-container>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            slide: 0,
            sliding: null,
            wurl: globalSiteSetting.siteurl,
            slideData: [],

            item_left_icon: 'ajaxloadercard.gif',
            item_left_title: '',
            item_left_resume: '',
            item_left_link: '',
            item_center_icon: 'ajaxloadercard.gif',
            item_center_title: '',
            item_center_resume: '',
            item_center_link: '',
            item_right_icon: 'ajaxloadercard.gif',
            item_right_title: '',
            item_right_resume: '',
            item_right_link: ''

        }
    },
    methods: {
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        retrievedataforslide() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=dynamicdata&p=slide&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('the response are:' + response.data[0].slide_file)
                    this.slideData = this.slideData.concat(response.data)
                })
        },
        retrievedataforhighlight() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=dynamicdata&p=home_highlight&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('the response are:' + response.data[0].item_left_icon)
                    //start to affect received data
                    this.item_left_icon = response.data[0].item_left_icon
                    this.item_left_title = response.data[0].item_left_title
                    this.item_left_resume = response.data[0].item_left_resume
                    this.item_left_link = response.data[0].item_left_link

                    this.item_center_icon = response.data[0].item_center_icon
                    this.item_center_title = response.data[0].item_center_title
                    this.item_center_resume = response.data[0].item_center_resume
                    this.item_center_link = response.data[0].item_center_link

                    this.item_right_icon = response.data[0].item_right_icon
                    this.item_right_title = response.data[0].item_right_title
                    this.item_right_resume = response.data[0].item_right_resume
                    this.item_right_link = response.data[0].item_right_link
                })
        }
    },
    mounted() {
        this.retrievedataforslide()
        this.retrievedataforhighlight()
    }
}
</script>
